const isLoggedIn = (status: string): boolean | undefined =>
    status === 'loading' ? undefined : status === 'authenticated';

export default isLoggedIn;
